import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ApplicationProcessRoutingModule } from './application-process-routing.module';
import { ApplicationProcessComponent } from './application-process.component';
import {AppModule} from '../../../app.module';
import {FormComponent} from '../form/form.component';
import {ReactiveFormsModule} from "@angular/forms";


@NgModule({
    declarations: [
        ApplicationProcessComponent,
        FormComponent
    ],
    exports: [
        FormComponent
    ],
    imports: [
        CommonModule,
        ApplicationProcessRoutingModule,
        ReactiveFormsModule,
        // AppModule,
    ]
})
export class ApplicationProcessModule { }
